import React from "react";
import {Box} from "@mui/material";

export function Header() {
  return <Box></Box>;
}
